import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  DataService,
  ModalService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import { DeleteQuestionDocument } from "../../generated-graphql/graphql";
export const bulkRemoveQuestions: BulkAction = {
  label: "Remove Questions",
  icon: "trash",
  iconClass: "is-danger",
  location: "qa-table",
  onClick: ({ selection, hostComponent, injector, clearSelection }) => {
    const dataService = injector.get(DataService);
    const modalService = injector.get(ModalService);
    const notificationService = injector.get(NotificationService);

    modalService
      .dialog({
        title: "Remove Questions",
        body: `Are you sure you want to remove ${selection.length} questions?`,
        buttons: [
          { label: "Cancel", type: "secondary" },
          { label: "Remove", type: "danger", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          const ids = selection.map((question: any) => question.id);
          const mutations = ids.map((id) =>
            dataService.mutate(DeleteQuestionDocument, { id })
          );
          forkJoin(mutations).subscribe(() => {
            notificationService.success(
              `Successfully removed ${selection.length} questions`
            );
            clearSelection();
            hostComponent.refresh();
          });
        }
      });
  },
};
